import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import { _showToast } from "../../../../../toastHelper";
import StepperNavigationButtons from "../../../MyInvitations/Common/StepperNavigationButtons";
import ImageBrowse from "../../../../Common/Image/ImageBrowse";

const DemoDetails = forwardRef(function DemoDetails(props, ref) {
  const [imageKey, setImageKey] = useState("");
  const [name, setName] = useState("");
  const [errors, setErrors] = useState({});
  const thumbnailRef = useRef();

  useEffect(() => {
    resetData();
    if (props.data) {
      setName(props.data.title);
      setImageKey(props.data.imageKey);
      thumbnailRef?.current?.setThumbnail(props.data.image && props.data.image != "" ? props.data.image : null);
      thumbnailRef?.current?.setFileContent(props.data.imageFile);
    }
  }, [props.data]);

  const resetData = () => {
    setName("");
    thumbnailRef?.current?.setThumbnail(null);
    thumbnailRef?.current?.setFileContent(null);
  }

  const validate = () => {
    const errors = {};

    if (!name || (name && name.trim() == "")) {
      errors.name = "Title is required";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  }

  const getData = () => {
    return {
      title: name,
      image: thumbnailRef?.current?.getThumbnail() ?? null,
      imageFile: thumbnailRef?.current?.getImageFile() ?? null,
      imageKey: imageKey
    };
  }

  useImperativeHandle(ref, () => ({
    getData: getData,
    validate: validate
  }));

  return (
    <>
      <div className="content" style={{ display: "block", visibility: "visible" }}>
        <div className="content-header mb-3">
          <div className="sec-titler">
            <h2 className="text-primary">Demo Details</h2>
            <div className="title-shape"></div>
          </div>
        </div>
        <form>
          <div className="row mt-4">
            <div className="col-sm-6">
              <label className="form-label required" htmlFor="demoTitle">
                Title
              </label>
              <input
                type="text"
                id="demoTitle"
                name="demoTitle"
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                placeholder="Enter Demo Title"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              {errors.name && (
                <div className="invalid-feedback">
                  {errors.name}
                </div>
              )}
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-sm-6">
              <label className="form-label" htmlFor="thumbnail">
                Thumbnail <small className="text-gray">(Max Allowable File Size: 1MB,Dimensions: 750px x 750px)</small>
              </label>
              <ImageBrowse elementId="demoThumbnail" ref={thumbnailRef} imageType="profile"
                imageKey={imageKey} setImageKey={setImageKey} imageDelete={props.imageDelete} />
            </div>
          </div>
          <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate} />
        </form>
      </div>
    </>
  );
});

export default DemoDetails;